module.exports = __webpack_public_path__ + "img/ins_step1.f6e1970a.svg";